{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Apply",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "TODAY": "Днес",
      "YESTERDAY": "Вчера",
      "LAST_7_DAYS": "Last 7 days",
      "LAST_30_DAYS": "Last 30 days",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_RANGE": "Custom date range"
    }
  }
}
